import React from 'react'

export default function NotFound() {
    return (
        <div style={{"fontSize":"300px"}}>
            Not Found
        </div>
    )
}
